import { WineryModel } from "./winery.model";

export class WineModel {
    Id: number;
    Name: string;
    WineryId: number;
    RegionId: number;
    VarietyId: number;
    WineCategoryId: number;
    VendorPremiumOverride: number;
    BuyerPremiumOverride: number;

    Winery: WineryModel;

    constructor() {
        this.Name = "";
    }
}